import * as React from 'react';
import { useEffect } from 'react';
import { useTheme } from '../../../../../../../theme';
import { useTranslation } from 'react-i18next';
import { useField } from 'react-final-form';
import MuiCheckbox from '@mui/material/Checkbox';
import { FormControlLabel } from '@mui/material';
import { AdditionalTravellerFieldEnum, PassengerField } from '../../../../../../../Passenger/types';
import { SafeHtml } from '@shared/ui';

interface Props {
	accompanyingFields: PassengerField[];
}

const Checkbox: React.FC<Props> = props => {
	const theme = useTheme('PassengerForm').Accompanying;
	const { t } = useTranslation('Passenger');

	const checkboxField = props.accompanyingFields.find(
		field => field.type === AdditionalTravellerFieldEnum.AccompanyingCheck
	);

	const { input, meta } = useField(`customer.${checkboxField.name}`, {
		type: 'checkbox',
		initialValue: checkboxField.defaultValue,
		validate: value => {
			if (!value) {
				return t('Required');
			}

			return undefined;
		}
	});

	useEffect(() => {
		input.onBlur();
	}, [input.value]);

	return (
		<div className={theme.checkbox}>
			<FormControlLabel
				control={
					<MuiCheckbox
						color={'primary'}
						classes={{
							root: theme.formControl__checkbox,
							checked: theme.checkbox__checked
						}}
						checked={input.checked}
						inputProps={{ ...input } as any}
					/>
				}
				classes={{
					label: theme.formControl__label
				}}
				label={
					<SafeHtml
						tag="div"
						html={t(
							'I confirm that the provided ticket number and the name of the accompanying passenger are correct and valid.'
						)}
					/>
				}
			/>
			<div className={theme.error}>{meta.submitFailed && meta.error}</div>
		</div>
	);
};

export default Checkbox;
